import React from "react";
import UpdatesBanner from "../UpdatesBanner/UpdatesBanner";
import SolutionEcosystem from "../WebSite/SolutionEcosystem/SolutionEcosystem";
import { Container } from "@material-ui/core";
import DeviceHubFeatures from "./DeviceHubFeatures";

import CTA from "../CTA/CTA";
import OverviewFeatures from "../OverviewFeatures/OverviewFeatures";
import DeviceHubBenefits from "./DeviceHubBenefits";

// Main component for DeviceHub
export default function DeviceHub() {
  // Data array containing descriptions of DeviceHub features
  const data1 = [
      "DeviceHub Gateway API: The Device Hub Gateway API includes token validation and directs requests to relevant services, streamlining communication within the Device Hub ecosystem.",
      "Communication Service: Communication Service acts as a proxy for the Core IoT server API, enabling manipulation of the broker through set APIs to streamline communication between devices and the IoT server.",
      "Security Service: The Security Service manages SSL certificates by generating, revoking, and renewing them, ensuring secure connections for SSL-enabled communication within the system.",
      "Command Publisher: The Command Publisher facilitates communication with devices through the MQTT protocol, allowing for the retrieval and modification of device property values, enhancing control and management capabilities remotely.",
      "Device Meta Data: Device Meta Data stores essential information about device types, models, and individual devices, serving as a central repository for managing device-related details within the system."
  ];
  
  // Data array containing additional system configurations and services
  const data2 = [
      "Configurations: Configurations store and manage server settings and parameters, providing a centralized location for configuring and maintaining server behavior within the system.",
      "Topic Manager: The Topic Manager sets and oversees topics for various entities, each with distinct topic types, facilitating organized and efficient communication within the system.",
      "Broker Service: The Broker Service transfers data between devices and services based on specified topics, enabling seamless communication and coordination within the system.",
      "IAM: IAM validates access tokens, ensuring secure and authorized access to resources and services within the system based on defined policies and permissions.",
      "DB: The database (db) stores configurations, device metadata, topics, and commands, serving as a central repository for managing crucial system information and facilitating efficient data retrieval and manipulation."
  ];

  return (
      <>
          {/* Banner section  */}
          <UpdatesBanner
              className="sdh-bg"
              bannerTitle={["DeviceHub Stack Experience"]}
              bannerbodycopy="Integrate | Connect | Manage | Operate"
          />
          
          {/* Overview section for DeviceHub */}
          <SolutionEcosystem title="Overview" type="DeviceHB" />

          {/* Container holding feature descriptions */}
          <Container>
              <OverviewFeatures data1={data1} data2={data2} />
          </Container>

          {/* Additional feature and benefit components */}
          <DeviceHubFeatures />
          <DeviceHubBenefits />

          {/* Call-to-action section for API access */}
          <Container className="subSectionWrapper">
              <CTA
                  href4="http://54.185.221.117:8900/v2/api-docs/"
                  heading="Do you want to develop applications or Integrate your legacy hardware and software..."
              />
          </Container>
      </>
  );
}

